import type {
  CreateLedgerAccountPayload,
  CreateLedgerAccountResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodCreateLedgerAccountPayloadSchema,
  zodCreateLedgerAccountResponseSchema,
} from './validations';

/**
 * Creates a new ledger account version (Sachkonto).
 *
 * @param payload - The ledger account data to create.
 * @returns The created ledger account version.
 * @throws VestigasHTTPError if the API request fails or validation fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Ledger-Accounts/operation/create_ledger_account_ledger_accounts_post
 */
export const createLedgerAccount = async (
  payload: CreateLedgerAccountPayload,
) =>
  vestigasApi
    .post(ENDPOINT.LEDGER_ACCOUNT.CREATE(), {
      json: payload,
      validate: {
        body: zodCreateLedgerAccountPayloadSchema,
        response: zodCreateLedgerAccountResponseSchema,
      },
    })
    .json<CreateLedgerAccountResponse>();
